import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import Icon from 'react-icons-kit';
import { withBaseIcon } from 'react-icons-kit';
import { priceTags } from 'react-icons-kit/icomoon/priceTags';
import { checkmark } from 'react-icons-kit/icomoon/checkmark';
import { cross } from 'react-icons-kit/icomoon/cross';
import { location2 } from 'react-icons-kit/icomoon/location2';
import { clipboard } from 'react-icons-kit/icomoon/clipboard';
import { facebook } from 'react-icons-kit/icomoon/facebook';
import { faInstagram } from '@fortawesome/free-brands-svg-icons';
import { ic_directions } from 'react-icons-kit/md/ic_directions';
import { faSyringe } from '@fortawesome/free-solid-svg-icons';
import { faSearch } from '@fortawesome/free-solid-svg-icons';
import { faMicrochip } from '@fortawesome/free-solid-svg-icons';
import { faHeartbeat } from '@fortawesome/free-solid-svg-icons';
import { faBug } from '@fortawesome/free-solid-svg-icons';
import { faEllipsisH } from '@fortawesome/free-solid-svg-icons';
import { faVials } from '@fortawesome/free-solid-svg-icons';
import { faTooth } from '@fortawesome/free-solid-svg-icons';

//lets say the icons on your side navigation are all color red
const TabIconContainer = withBaseIcon({ size: 30 });

const TableIconContainer = withBaseIcon({ size: 15 });

export const PriceTag1 = () => <TabIconContainer icon={priceTags} />;
export const Location = () => <TabIconContainer icon={location2} />;
export const Clipboard = () => <TabIconContainer icon={clipboard} />;
export const Facebook = () => <TabIconContainer icon={facebook} />;
export const Instagram = () => <FontAwesomeIcon icon={faInstagram} size="2x" />;
export const PhoneIcon = () => (
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" width="1em" height="1em">
    <path
      fill="currentColor"
      d="M6.62 10.79c1.44 2.83 3.76 5.14 6.59 6.59l2.2-2.2c.27-.27.67-.36 1.02-.24c1.12.37 2.33.57 3.57.57c.55 0 1 .45 1 1V20c0 .55-.45 1-1 1c-9.39 0-17-7.61-17-17c0-.55.45-1 1-1h3.5c.55 0 1 .45 1 1c0 1.25.2 2.45.57 3.57c.11.35.03.74-.25 1.02z"
    ></path>
  </svg>
);
export const Checkmark = () => <TableIconContainer icon={checkmark} />;
export const Cross = () => <TableIconContainer icon={cross} />;
export const Directions = () => <Icon icon={ic_directions} size={30} />;
export const Syringe = () => <FontAwesomeIcon icon={faSyringe} />;
export const Search = () => <FontAwesomeIcon icon={faSearch} />;
export const Microchip = () => <FontAwesomeIcon icon={faMicrochip} />;
export const Heartbeat = () => <FontAwesomeIcon icon={faHeartbeat} />;
export const Insect = () => <FontAwesomeIcon icon={faBug} />;
export const HorizontalEllipses = () => <FontAwesomeIcon icon={faEllipsisH} />;
export const Vials = () => <FontAwesomeIcon icon={faVials} />;
export const Tooth = () => <FontAwesomeIcon icon={faTooth} />;
